module.exports = __webpack_public_path__ + "img/cross.d8ae913b.svg";